export enum NEWSLETTER {
    /**
     * @value Newsletters
     */
    NEWSLETTER_KEY = 'ADMIN.NAV.NEWSLETTER',
}
